import { render, staticRenderFns } from "./CategoryCardmap.vue?vue&type=template&id=1a4a0dd5&scoped=true&"
import script from "./CategoryCardmap.vue?vue&type=script&lang=js&"
export * from "./CategoryCardmap.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCardmap.vue?vue&type=style&index=0&id=1a4a0dd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4a0dd5",
  null
  
)

export default component.exports